module.exports = __webpack_public_path__ + "static/media/Avatars_Female-23.7ba3913d.png";